 import React, { Fragment,useState } from 'react';
import { Container, Col, Row, Card, CardBody, Button, Table, ButtonGroup,Input,
    Dropdown,DropdownMenu, DropdownItem ,DropdownToggle } from 'reactstrap';
import { useProfiles } from '../../../hooks/profiles/useProfiles';
import { ModalViewProfiles } from './ModalViewProfiles';
import { ModalDelete } from './ModalDelete';
import { ModalViewProfilesCommercial } from './ModalViewProfilesCommercial';
import { DialogProfileIndications } from './DialogProfileIndications';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';


export const IndexProfile = () => {

    const {
        profiles, navigateUpdate, listProfile, handleListProfile,
        modal, toggle, modalTitle, method,
        handleDelete, saveDelete, name, abbreviation, code,
        toggle2, modal2, navigateUpdateP,
        handleListComercial, modal3, toggle3, listCommercial,
        navigateCosts,
        totalPageCount, currentPage, nextPage, previousPage, goToPage,handleSearchProfile,
        pruebas, 
        //Global
        navigateGlobal, 

          // ? Profiles Indications
        visibleDialog, setVisibleDialog,   
        handleSelectValuesIndication, handleSelectValuesIndication2, dataIndication, dataIndicationLab, handleListProfiles,
        listIndication, listIndicationLab, handleSaveAllIndications, exportProfilesToExcel,

        //? ORDER EXAM
        loadingOrder

    } = useProfiles();
        // console.log("🚀 ~ IndexProfile ~ profiles:", profiles)


    const headerStyle = {
        backgroundColor: "#1d5b83",
        color: "#fff",
        fontWeight: "bold",
        fontSize: "11px",
        borderRight: "1px solid #fff",
        borderBottom: "2px solid #fff",
    };

    const cellStyle = {
        fontSize: "11px",
        padding: "5px",
        textAlign: "center",
        fontFamily: "Montserrat, sans-serif",

    };
                                      
    const actions = (rowData) => {

        return (
            <div className="d-flex justify-content-center align-items-center" style={{ gap: "3px", marginRight: "3px" }}>
                <Button
                    size="sm"
                    onClick={() => navigateUpdateP(rowData.id_profile)}
                    title="Editar Perfil"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <i className="fa fa-edit"></i>
                </Button>

                <button
                    size="sm"
                    onClick={() => navigateCosts(rowData.id_profile)}
                    title="Costo de Perfil en Kit Toma de Muestra"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#F44336", 
                        color: "#fff",               
                        border: "none",             
                        borderRadius: "4px"          
                    }}
                >
                    <i className="fa fa-medkit f-14"></i>
                </button>

                <button
                    size="sm"
                    onClick={() => navigateGlobal(rowData.id_profile)}
                    title="Valores de referencia del perfil"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#9E114A", 
                        color: "#fff",               
                        border: "none",             
                        borderRadius: "4px"          
                    }}
                >
                    <i className="fa fa-cogs f-14"></i>
                </button>

                <button
                    size="sm"
                    onClick={() => handleListProfiles(rowData.id_profile)}
                    title="Indicaciones del perfil"
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        backgroundColor: "#17a2b8", 
                        color: "#fff",               
                        border: "none",             
                        borderRadius: "4px"          
                    }}
                >
                    <i className="icofont icofont-prescription"></i>
                </button>


                <Button 
                    color="danger" 
                    size="sm"
                    onClick={() => handleDelete(rowData.id_profile)}
                    style={{
                        padding: "2px",
                        fontSize: "1rem",
                        height: "26px",
                        width: "26px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }}
                >
                    <i className="fa fa-trash"></i>
                </Button>
            </div>
        );
    };

    const header = (
        <div className="d-flex align-items-center justify-content-between w-100" style={{ gap: '1rem', marginBottom: '1rem' }}>
            <Button
                color="success"
                onClick={() => exportProfilesToExcel(profiles)} 
                size="sm"
                title="Exportar a Excel"
                style={{ 
                    padding: "2px 6px", 
                    height: "28px", 
                    fontSize: "0.8rem", 
                    borderRadius: "6px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                }}
            >
                <i className="pi pi-file-excel me-1" />
            </Button>

            <Input
                placeholder='Busqueda...'
                className='form-control form-control-sm'
                onChange={handleSearchProfile}
                style={{ maxWidth: '450px', width: '100%' }}
            />
        </div>
    );



    return (
        <Fragment>
            <div className='container-global-zoom'> 
                <Row>
                    <Col sm="12">
                        <Card >
                            <CardBody className="p-1">
                                <div className="ribbon ribbon-clip ribbon-primary">
                                    Listado de perfiles
                                </div>
                                <div className="text-right" style={{ margin: 5, paddingBottom: 10 }}>
                                    <Button className="btn btn-pill btn-air-success" color="secondary" size="sm" onClick={() => navigateUpdate()}>
                                        <span className="fa fa-plus-circle"></span>
                                    </Button>
                                </div>
                               
                                <div className="table-responsive">
                              
                                    <DataTable
                                    value={profiles}
                                    paginator 
                                    rows={10} 
                                    className="data-table p-datatable-striped p-datatable-sm"
                                    emptyMessage={
                                        <div className="text-center">
                                            <img src={require("../../../assets/images/loginHelenLabs/dashboard/recepcionista.svg")} style={{ width: "25%" }} alt="Sin Cotizaciones" />
                                            <br />
                                            <p className='badge badge-light-primary mt-2' style={{ fontSize: "15px" }}>
                                                Sin Perfiles.
                                            </p>
                                        </div>
                                    }
                                    rowsPerPageOptions={[10, 50, 100]}
                                    responsiveLayout="scroll"
                                    header={header}
                                >
                                    <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="#" headerStyle={headerStyle} style={cellStyle} />
                                    <Column field="name" header="Nombre" sortable headerStyle={headerStyle} style={cellStyle}/>
                                    <Column field="abbreviation" header="Abreviatura" headerStyle={headerStyle} style={cellStyle}/>
                                    <Column field="code" header="Clave" sortable headerStyle={headerStyle} style={cellStyle}/>
                                    <Column 
                                        header="Exámenes" 
                                        body={(rowData) => { 
                                            const totalExams = rowData.profileExams ? rowData.profileExams.length : 0; 
                                            return (
                                                <span
                                                    onClick={() => handleListProfile(rowData.id_profile)}
                                                    style={{
                                                        cursor: "pointer",
                                                        color: "#fff",
                                                        backgroundColor: "#25acd4ff",
                                                        padding: "4px 8px",
                                                        borderRadius: "12px",
                                                        fontSize: "10px",
                                                        display: "inline-block"
                                                    }}
                                                    title="Ver exámenes"
                                                >
                                                    {totalExams} {totalExams === 1 ? "Examen" : "Exámenes"}
                                                </span>
                                            );
                                        }} 
                                        headerStyle={headerStyle} 
                                        style={cellStyle} 
                                    />


                                    
                                    <Column
                                        header="Precios"
                                        body={(rowData) => {
                                            if (!rowData.priceProfileViewModel || rowData.priceProfileViewModel.length === 0) {
                                                return (
                                                    <div style={{ fontStyle: "italic", color: "#6c757d", textAlign: "center", fontSize: "0.8rem" }}>
                                                        Sin precios
                                                    </div>
                                                );
                                            }

                                            const preciosConcatenados = rowData.priceProfileViewModel
                                                .map((price) => `$${price.price}`)
                                                .join(" - ");

                                            return (
                                                <span
                                                    onClick={() => handleListComercial(rowData.id_profile)}
                                                    style={{
                                                        cursor: "pointer",
                                                        color: "#fff",
                                                        backgroundColor: "#ff9137ff",
                                                        padding: "4px 8px",
                                                        borderRadius: "12px",
                                                        fontSize: "11px",
                                                        display: "inline-block",
                                                        textAlign: "center"
                                                    }}
                                                    title="Ver precios"
                                                >
                                                    {preciosConcatenados}
                                                </span>
                                            );
                                        }}
                                        headerStyle={headerStyle}
                                        style={cellStyle}
                                    />


                                    <Column header="Acciones" body={actions} exportable={false} headerStyle={headerStyle} style={cellStyle} />
                                </DataTable>
                               
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </div>
            <ModalViewProfiles
                {
                ...{
                    modal, toggle, modalTitle, method, listProfile
                }
                }
            />
            <ModalViewProfilesCommercial
                {
                ...{
                    modal3, toggle3, modalTitle, method, listCommercial
                }
                }
            />
            <ModalDelete
                {
                ...{
                    modal2, toggle2, modalTitle, method, name, abbreviation, saveDelete
                }
                }
            />
             <DialogProfileIndications
                {
                    ...{
                            visibleDialog, setVisibleDialog, handleSelectValuesIndication, handleSelectValuesIndication2, dataIndication, dataIndicationLab, 
                            handleListProfiles, listIndication,listIndicationLab, handleSaveAllIndications


                       }
                }
            />
        </Fragment>
    )
}
